import { datadogRum } from "@datadog/browser-rum";
import { datadogLogs } from "@datadog/browser-logs";

export const setDatadogUser = (user: { id: string; name: string; email: string }) => {
  localStorage.setItem("datadogUser", JSON.stringify(user));

  datadogRum.setUser(user);
  datadogLogs.setGlobalContext({
    userId: user.id,
    userName: user.name,
    userEmail: user.email,
  });
};
